<section class="advisor-teaser-wrapper">
  <div class="grid-x grid-margin-x">
    <div class="cell medium-{{showImage? 4 : 12}}" [class.medium-order-2]="changeColumnOrder">
      <h2 [innerHTML]="textPrefix + '.headline' + headlinePostfix | translate"></h2>
      @if (showImage) {
        <app-advisor-image [path]=image></app-advisor-image>
      }
    </div>
    <div class="cell medium-{{showImage? 8 : 12}}" [class.medium-order-1]="changeColumnOrder">
      <div class="teaser">
        <p [innerHTML]="textPrefix + textPostfix| translate: placeholder"></p>
        @if (url) {
          <a [href]="url" [target]="target" class="button inline-arrow-right"
             [class.signal2]="isInternalPortal" [class.primary]="!isInternalPortal"
             [innerHTML]="textPrefix + '.button' + textPostfix | translate"></a>
        }
      </div>
      <div class="text-center">
        @if (mailUrl) {
          <div class="mail-wrapper">
            <i class="icon-mail"></i>
            <span [innerHTML]="textPrefix + '.mail.hint' | translate"></span>
            <a
              href="mailto:?subject={{textPrefix + '.mail.subject' | translate: {url: mailUrl} }}&body={{textPrefix + '.mail.body' | translate: {url: mailUrl} }}"
              target="_blank" [innerHTML]="textPrefix + '.mail.link' | translate"></a>
          </div>
        }
      </div>
    </div>

  </div>
</section>
